import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { CompanyProfile } from "../../company";
import { getCompanyProfile } from "../../api";
import Sidebar from "../../Components/Sidebar/Sidebar";
import CompanyDashboard from "../../Components/CompanyDashboard/CompanyDashboard";
import Tile from "../../Components/Tile/Tile";
import CompFinder from "../../Components/CompFinder/CompFinder";
import TenKFinder from "../../Components/TenKFinder/TenKFinder";
import { formatLargeMonetaryNumber } from "../../Components/Helpers/NumberFormatting";
import DescriptionTile from "../../Components/Tile/DescriptionTile";

interface Props {}

const CompanyPage = (props: Props) => {
  let { ticker } = useParams();
  const [company, setCompany] = useState<CompanyProfile>();

  const formatMarketCap = (value?: number) => {
    if (!value && value !== 0) return "N/A";
    const formatted = formatLargeMonetaryNumber(Number(value));
    // formatted examples: "$1.35T", "$12.5B", "$900", "$0.00"
    const withoutDollar = formatted.replace(/^\$/, "");
    const map: Record<string, string> = {
      K: "Thousand",
      M: "Million",
      B: "Billion",
      T: "Trillion",
    };
    const m = withoutDollar.match(/^([0-9.,]+)\s*([KMBT])?$/);
    if (!m) return withoutDollar;
    const num = m[1];
    const suffix = m[2];
    return suffix ? `${num} ${map[suffix]}` : num;
  };

  useEffect(() => {
    const getProfileInit = async () => {
      try {
        const result = await getCompanyProfile(ticker!);
        // Using optional chaining ?.[0] just in case data is undefined
        setCompany(result?.data?.[0]);
      } catch (error) {
        console.error("Failed to fetch company data:", error);
        // Ensure company is cleared out if the request fails
        setCompany(undefined);
      }
    };
    getProfileInit();
  }, [ticker]);
  return (
    <>
      {company ? (
        <div className="w-full relative flex ct-docs-disable-sidebar-content overflow-x-auto">
          <Sidebar />
          <CompanyDashboard ticker={ticker!}>
            <Tile title="Company Name" subTitle={company.companyName}></Tile>
            <Tile title="Price" subTitle={`${company.price} ${company.currency}`}></Tile>
            <Tile title="Sector" subTitle={company.sector}></Tile>
            <Tile
              title="Market Cap"
              subTitle={`${formatMarketCap(company.marketCap)} ${company.currency}`}
            ></Tile>
            <CompFinder ticker={company.symbol} />
            <TenKFinder ticker={company.symbol} />
            <DescriptionTile title="About" subTitle={company.description} collapseCharLimit={255} />
          </CompanyDashboard>
        </div>
      ) : (
        <div>Company not found!</div>
      )}
    </>
  );
};

export default CompanyPage;
